import React from 'react';
import classNames from 'classnames';
import Image from '@lib/components/Image/Image';
import TextEditor from '@lib/components/TextEditor/TextEditor';
import Typography from '@lib/components/Typography/Typography';
import { ChipTypes } from '@lib/components/Chip/Chip';
import NewBadge from '../../NewBadge';
import styles from './AnnouncementWidget.module.scss';

interface AnnouncementWidgetProps {
  title?: string | null;
  description?: string | null;
  backgroundColor?: ChipTypes | null;
  imageSrc?: string | null;
  showBadge?: boolean;
}

export default function AnnouncementWidget({
  title,
  description,
  backgroundColor,
  imageSrc,
  showBadge = false,
}: AnnouncementWidgetProps) {
  const containerClassName = classNames(styles.container, {
    [styles[backgroundColor as string]]: backgroundColor,
  });

  return (
    <div className={containerClassName}>
      {showBadge && <NewBadge className={styles.badge} />}
      <div className={styles.scrollWrapper}>
        <div className={styles.content}>
          {imageSrc && (
            <div className={styles.imageWrapper}>
              <Image
                src={imageSrc}
                className={styles.image}
                alt={title || ''}
              />
            </div>
          )}
          <div className={styles.textContent}>
            {title && (
              <Typography variant="h3" className={styles.title}>
                {title}
              </Typography>
            )}
            {description && (
              <TextEditor
                readOnly
                useCollapse={false}
                value={description}
                className={styles.description}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.gradientOverlay} />
    </div>
  );
}
